module.exports = __webpack_public_path__ + "img/gyonyoru_szuleim_anya_rozsaval.4a3579c2.jpg";